import { gql } from '@apollo/client'
import { graphql } from 'gql/generated'

export const CREATE_BUSINESS_CLIENT_USER = graphql(`
  mutation CreateBusinessClientUser($input: CreateBusinessClientUserInput!) {
    createBusinessClientUser(input: $input)
  }
`)
//TODO: Change to graphql
export const CHANGE_BUSINESS_CLIENT_USER = gql`
  mutation ChangeBusinessClientUser($input: ChangeBusinessClientUserInput!) {
    changeBusinessClientUser(input: $input)
  }
`

export const ACTIVATE_BUSINESS_CLIENT = graphql(`
  mutation ActivateBusinessClient($id: UUID!) {
    activateBusinessClient(id: $id)
  }
`)

export const DEACTIVATE_BUSINESS_CLIENT = graphql(`
  mutation DeactivateBusinessClient($id: UUID!) {
    deactivateBusinessClient(id: $id)
  }
`)

export const ACTIVATE_BUSINESS_CLIENT_USER = graphql(`
  mutation ActivateBusinessClientUser($input: ActivateBusinessClientUserInput!) {
    activateBusinessClientUser(input: $input)
  }
`)

export const DEACTIVATE_BUSINESS_CLIENT_USER = graphql(`
  mutation DeactivateBusinessClientUser($input: DeactivateBusinessClientUserInput!) {
    deactivateBusinessClientUser(input: $input)
  }
`)

export const ASSIGN_BUSINESS_CLIENT_SIMS = graphql(`
  mutation AssignBusinessClientSims($input: AssignBusinessClientSimsInput!) {
    assignBusinessClientSims(input: $input)
  }
`)

export const REQUEST_BUSINESS_CLIENT_KREDIT_DEPOSIT = graphql(`
  mutation RequestBusinessClientKreditDeposit($input: RequestBusinessClientKreditDepositInput!) {
    requestBusinessClientKreditDeposit(input: $input)
  }
`)

export const CANCEL_BUSINESS_CLIENT_KREDIT_DEPOSIT = graphql(`
  mutation CancelBusinessClientKreditDeposit($input: CancelBusinessClientKreditDepositInput!) {
    cancelBusinessClientKreditDeposit(input: $input)
  }
`)

export const CHANGE_BUSINESS_CLIENT_USER_BUSINESS_CLIENT = graphql(`
  mutation ChangeBusinessClientUserBusinessClient($input: ChangeBusinessClientUserBusinessClientInput!) {
    changeBusinessClientUserBusinessClient(input: $input)
  }
`)
